import { BrowserRouter as Router, Link, Route, Routes } from "react-router-dom";
import "./App.css";
import CardList from "./components/CardList";

function App() {
  return (
    <div className="App">
      <Router>
        {/* <Link to="/list">List</Link>
        <Link to="/test">Test</Link> */}
        <header className="App-header"></header>
        <main>
          <Routes>
            <Route path="/" element={<CardList />} />
          </Routes>
        </main>
      </Router>
    </div>
  );
}

export default App;
